// External packages
import * as React from 'react';

export function useTranslationSelection<T extends { languageCode: string }>(
  translations: T[]
) {
  const languageOptions = React.useMemo(
    () =>
      translations.map((t) => ({
        key: t.languageCode,
        label: t.languageCode.toUpperCase(),
      })),
    [translations]
  );

  const [selectedLanguage, setSelectedLanguage] = React.useState('');

  React.useEffect(() => {
    setSelectedLanguage(languageOptions[0]?.key || '');
  }, [languageOptions]);

  const translation = React.useMemo(() => {
    if (!selectedLanguage) return translations[0];
    return (
      translations.find((t) => t.languageCode === selectedLanguage) ||
      translations[0]
    );
  }, [translations, selectedLanguage]);

  return {
    translation,
    selectedLanguage,
    setSelectedLanguage,
    languageOptions,
  };
}
